// TODO: None of this data is accurate. It's just a placeholder for now!!!!!!!
export const bartYellowLineExt = [
    [37.82856302088743, -122.26714533790053], // BART MacArthur
    [37.83332309515771, -122.26609947364275],
    [37.83798270660318, -122.26535093446154],
    [37.83963191044778, -122.26430672728887],
    [37.8410951667387, -122.26188578516758],
    [37.84641849355846, -122.24725435433764],
    [37.8527177239343, -122.23511973541981],
    [37.87208840234724, -122.19245927314324],
    [37.87549322955064, -122.18662022241716],
    [37.87632808938979, -122.18538001124364],
    [37.87750624812141, -122.18443118031215],
    [37.878426332938204, -122.18381305563317], // BART Orinda
    [37.883050248976424, -122.18027394031216],
    [37.88685791294243, -122.17791045795018],
    [37.88818061832787, -122.17678371425406],
    [37.8893737595126, -122.17546783447149],
    [37.890597480183544, -122.17360756471265],
    [37.89157454484194, -122.17124790787884],
    [37.8923411576893, -122.16863788324036],
    [37.89291198472522, -122.16472356015375],
    [37.89298702421714, -122.16198058862366],
    [37.89286648224196, -122.16045669367837],
    [37.89259944053407, -122.158277520674],
    [37.89125838943216, -122.14918756292876],
    [37.89117960589884, -122.14810644139732],
    [37.89123486969226, -122.146715711535],
    [37.89148338683103, -122.1440890481967],
    [37.891452630563435, -122.14266505211368],
    [37.891298185920675, -122.14110062639476],
    [37.89068814810668, -122.13724252606961],
    [37.89064182405148, -122.13609170248174],
    [37.890765702882284, -122.1346983973363],
    [37.89096696181012, -122.13364369467763],
    [37.893143486574765, -122.1248926537727], // BART Lafayette
    [37.89382724948921, -122.12181774719257],
    [37.89400362367819, -122.12078721762947],
    [37.89567602157894, -122.11044222174705],
    [37.89750634072926, -122.0994129732165],
    [37.89767947971316, -122.0974653242924],
    [37.897988333035556, -122.08526268883581],
    [37.897449738192655, -122.07971177957772],
    [37.897383550160825, -122.07801649971688],
    [37.89768248909144, -122.07585252409467],
    [37.898280512645236, -122.07403383417348],
    [37.8987707524896, -122.07302700716363],
    [37.899813764652336, -122.07146344065404],
    [37.901482013704154, -122.06992796446013],
    [37.902299122964955, -122.06941468170321],
    [37.905773610891735, -122.0673594024863], // BART Walnut Creek
    [37.90989576495929, -122.06490182331179],
    [37.91049556142279, -122.06457767591377],
    [37.9119182816492, -122.0641108306747],
    [37.91472458869952, -122.06365352834996],
    [37.91617086998761, -122.06341242697516],
    [37.91773156578292, -122.06280134898367],
    [37.91978193220434, -122.06182692615766],
    [37.923944692210306, -122.06031561897947],
    [37.925724530820375, -122.05906633459183],
    [37.92656860749837, -122.05834412781552],
    [37.92853407430748, -122.05647654200932], // BART Pleasant Hill
    [37.93107962693149, -122.0525458980266],
    [37.9438693818923, -122.02790376264086],
    [37.94515939431813, -122.0262914718216],
    [37.94590138293039, -122.02562543910251],
    [37.947035013927675, -122.02515342701524],
    [37.94829231978157, -122.02488370772099],
    [37.94930196204861, -122.02500722448204],
    [37.95022466371535, -122.02521978613596],
    [37.96493379632905, -122.0311510610106],
    [37.96604497608268, -122.0314059151097],
    [37.9667375933585, -122.03141605106248],
    [37.967700356828736, -122.03139219302241],
    [37.96838656433548, -122.0313017616519],
    [37.96921031307285, -122.03104323087028],
    [37.97374235714705, -122.0291756175564], // BART Concord
    [37.97494231209542, -122.02858697884639],
    [37.97649181796571, -122.02832918704244],
    [37.97745043860745, -122.02861040881572],
    [37.978083243009685, -122.02901181456257],
    [37.978985704251585, -122.02971403907372],
    [37.97980338929637, -122.03020491564355],
    [37.986480610329394, -122.03307610956882],
    [37.988059725026964, -122.03348210739784],
    [37.98948173211274, -122.03364977403164],
    [37.99110879831406, -122.03327695839997],
    [37.99304932018458, -122.03230875159291],
    [37.995366313769466, -122.03063069776803],
    [38.000463232444105, -122.02692323255346],
    [38.003382471708434, -122.0245013034809], // BART North Concord/Martinez
    [38.00919338744504, -122.01976364268293],
    [38.01004634242891, -122.0184226027391],
    [38.01053878884561, -122.01703830479848],
    [38.01068320294408, -122.01627508795923],
    [38.01332589366144, -121.99912440737576],
    [38.014066215371905, -121.99643242590933],
    [38.01458165374436, -121.99499070934856],
    [38.01658234074557, -121.99145996528135],
    [38.01808072337632, -121.9889523684692],
    [38.019342066330424, -121.9861883968981],
    [38.02272153826478, -121.97847404819149],
    [38.02345166077297, -121.9756713382577],
    [38.02373120690887, -121.97436600176748],
    [38.02378335692822, -121.97056067024619],
    [38.02369767210994, -121.9700330843248],
    [38.02345627190178, -121.96869110848006],
    [38.02114929686828, -121.9564605270435],
    [38.02051384236086, -121.95371344245163],
    [38.019470903068864, -121.95040466252848],
    [38.01896590310714, -121.947928676831],
    [38.01892309977207, -121.9465038921864],
    [38.018923626592326, -121.94496816541205], // BART Pittsburg/Bay Point
    [38.018959724919654, -121.93281068737643], // BART Pittsburg / Bay Point Transfer
    [38.01892406649353, -121.93055852118547],
    [38.01909866483921, -121.92730603401318],
    [38.019405005713644, -121.92503477314251],
    [38.01978109212852, -121.92296253967429],
    [38.0200897542764, -121.9203414377174],
    [38.019975888509265, -121.90430527808117],
    [38.01977230333283, -121.90126983268489],
    [38.019332594491644, -121.89849209982411],
    [38.01912040797289, -121.8976155710777],
    [38.017647822148376, -121.89233223665872],
    [38.01688476231417, -121.88911941252681], // BART Pittsburg Center
    [38.01451834944617, -121.87936462731422],
    [38.013392097347094, -121.87461418304282],
    [38.010211991680094, -121.86043694727147],
    [37.9986659214113, -121.81867863662617],
    [37.9983988702629, -121.8173119372478],
    [37.998266174313024, -121.8153444442825],
    [37.9982087886134, -121.79799906478235],
    [37.998046489560004, -121.79620495556547],
    [37.99541990241839, -121.78047419709443], // BART Antioch
];